import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import frFR from 'antd/locale/fr_FR';
import { Header, Footer } from './components';
import { HomePage, FeaturesPage, FeatureDetailPage, AvantagesPage, AboutPage, ContactPage, AffiliePage, AffiliateRegisterPage, AffiliateLoginPage, AffiliateDashboardPage, AmbassadorPage, AmbassadorRegisterPage, AmbassadorLoginPage, AmbassadorDashboardPage, DriverLoginPage, DriverRankingPage, PrivacyPage } from './pages';
import './App.css';
import './styles/animations.css';

// Theme configuration - TIGOON Gold Colors
const theme = {
  token: {
    colorPrimary: '#D4A853',
    colorLink: '#D4A853',
    colorLinkHover: '#B8912F',
    borderRadius: 8,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
};

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// Layout component that conditionally shows Header/Footer
const AppLayout = () => {
  const location = useLocation();
  const isDashboard = location.pathname.includes('/dashboard');

  return (
    <div className="app">
      <ScrollToTop />
      {!isDashboard && <Header />}
      <main className={isDashboard ? "dashboard-main" : "main-content"}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/features/:featureKey" element={<FeatureDetailPage />} />
          <Route path="/avantages" element={<AvantagesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/affilies" element={<AffiliePage />} />
          <Route path="/affilies/inscription" element={<AffiliateRegisterPage />} />
          <Route path="/affilies/connexion" element={<AffiliateLoginPage />} />
          <Route path="/affilies/dashboard" element={<AffiliateDashboardPage />} />
          <Route path="/ambassadeurs" element={<AmbassadorPage />} />
          <Route path="/ambassadeurs/inscription" element={<AmbassadorRegisterPage />} />
          <Route path="/ambassadeurs/connexion" element={<AmbassadorLoginPage />} />
          <Route path="/ambassadeurs/dashboard" element={<AmbassadorDashboardPage />} />
          <Route path="/chauffeurs/connexion" element={<DriverLoginPage />} />
          <Route path="/chauffeurs/classement" element={<DriverRankingPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
        </Routes>
      </main>
      {!isDashboard && <Footer />}
    </div>
  );
};

function App() {
  return (
    <ConfigProvider theme={theme} locale={frFR}>
      <Router>
        <AppLayout />
      </Router>
    </ConfigProvider>
  );
}

export default App;
